import React from 'react';
import { useSelector } from 'react-redux';

import { deactivateProviderDrawerSections } from '@common/constants';
import DynamicFormWidget from '@components/dynamic-form/DynamicFormWidget';
import { RootState } from '@core/redux/store';
import { IGeneralDetails } from '@features/salesforce/providers';
import { useDeactivateProvider } from '@features/salesforce/providers/providers.slice';

import { useFormik } from 'formik';
import * as Yup from 'yup';

interface Props {
  onSuccess: () => void;
  data?: IGeneralDetails;
}

const DeactivateProviderDrawer: React.FC<Props> = ({
  onSuccess,
  data
}: Props) => {
  const buttonState = useSelector(
    (state: RootState) => state.apiState.buttonState
  );

  const [deactivateProvider] = useDeactivateProvider(data.id);

  const deactivateProviderFormik = useFormik({
    initialValues: {
      contractStartDate: data?.contractStartDate,
      contractEndDate: new Date().toISOString()
    },
    validationSchema: Yup.object({
      contractEndDate: Yup.date().required('Required')
    }),
    onSubmit: async (values) => {
      await deactivateProvider({
        providerId: data.id,
        deactivateProviderInput: {
          contractEndDate: values.contractEndDate
        }
      }).then((d) => {
        if (!d.errors) {
          setTimeout(onSuccess, 500);
        }
      });
    }
  });

  const handleChange = async (
    fieldName: string,
    value: string | number | boolean
  ) => {
    deactivateProviderFormik.setFieldValue(fieldName, value);
    deactivateProviderFormik.setFieldTouched(fieldName, true);
  };

  return (
    <div>
      <DynamicFormWidget
        onChange={handleChange}
        sections={deactivateProviderDrawerSections(deactivateProviderFormik)}
        disableForm={false}
        onSubmit={() => deactivateProviderFormik.handleSubmit()}
        submitButtonState={buttonState}
      />
    </div>
  );
};

export { DeactivateProviderDrawer };
